import React, { FC, memo } from 'react';
import styled from 'styled-components';
import FormikSelect from '@minecraft.formik-select';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FilterData } from '../../../shared/types';
import { getOptionsWithEmptyOption } from '../../../shared/utils';
import { Label } from '../../../shared/styles';
import { FiltersCategoryNameEnum } from '../../shared/types';

const StyledFormikSelect = styled(FormikSelect)`
  min-width: 9.375rem;
`;

type Props = FilterData;

const VehicleMake: FC<Props> = ({ name, label }) => {
  const { getMatchedSearchOptions } = useDrawerSearchFilterNameOrCategory(FiltersCategoryNameEnum.vehicle);

  return (
    <>
      <Label>{label}</Label>
      <StyledFormikSelect
        saveAsOption
        name={name}
        size="small"
        options={getOptionsWithEmptyOption(getMatchedSearchOptions(name))}
      />
    </>
  );
};

export default memo(VehicleMake);
